import { Button, Grid, Typography } from "@mui/material";
import {
  ReactElement,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import useFetchMsal from "../hook/useFetchMsal";
import { theme } from "../styles/theme";
import "./IntegrationStatuses.css";
import AlbumIcon from "@mui/icons-material/Album";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { appRoles, config } from "../../../authConfig";
import { CardContainer } from "./CardContainer";
import { LoadingIndicator } from "./Loading";
import CreateTicket from "./CreateTicket";
import AddIcon from "@mui/icons-material/Add";

interface IntegrationObject {
  urlParam: string,
  setter: React.Dispatch<React.SetStateAction<boolean | null>>,
  loadingSetter: React.Dispatch<React.SetStateAction<boolean>>
}

function IntegrationStatuses({
  showDateFilter = false,
}: {
  showDateFilter?: boolean;
}): ReactElement {
  const [punchesValidation, setPunchesValidation] = useState<boolean | null>(null);
  const [punchesAdjValidation, setPunchesAdjValidation] = useState<boolean | null>(null);
  const [rewardsValidation, setRewardsValidation] = useState<boolean | null>(null);
  const [dailyPayValidation, setDailyPayValidation] = useState<boolean | null>(null);
  const [crunchTimeValidation, setCrunchTimeValidation] = useState<boolean | null>(null);
  const [domoValidation, setDomoValidation] = useState<boolean | null>(null);
  const [domoCuratedValidation, setDomoCuratedValidation] = useState<boolean | null>(null);
  const [microsSalesMenuItemsValidation, setMicrosSalesMenuItemsValidation] = useState<boolean | null>(null);
  const [microsSalesOtherValidation, setMicrosSalesOtherValidation] = useState<boolean | null>(null);
  const [microsSalesMiscValidation, setMicrosSalesMiscValidation] = useState<boolean | null>(null);
  const [microsDimensionsValidation, setMicrosDimensionsValidation] = useState<boolean | null>(null);
  const [microsEmployeeInfoValidation, setMicrosEmployeeInfoValidation] = useState<boolean | null>(null);

  const [oloOrdersExportValidation, setOloOrdersExportValidation] = useState<boolean | null>(null);
  const [oloOrdersValidation, setOloOrdersValidation] = useState<boolean | null>(null);
  const [oloRestaurantsValidation, setOloRestaurantsValidation] = useState<boolean | null>(null);
  const [oloRestaurantsHOOValidation, setOloRestaurantsHOOValidation] = useState<boolean | null>(null);
  const [oloOrdersExportCateringValidation, setOloOrdersExportCateringValidation] = useState<boolean | null>(null);
  const [oloOrdersCateringValidation, setOloOrdersCateringValidation] = useState<boolean | null>(null);
  const [mergeOloOptInValidation, setMergeOloOptInValidation] = useState<boolean | null>(null);
  const [oloRefundOrderValidation, setOloRefundOrderValidation] = useState<boolean | null>(null);
  const [oloCancelOrderValidation, setOloCancelOrderValidation] = useState<boolean | null>(null);
  const [ultiProLaborValidation, setUltiProLaborValidation] = useState<boolean | null>(null);
  const [microsEmployeePunchesValidation, setMicrosEmployeePunchesValidation] = useState<boolean | null>(null);

  const [biteValidation, setBiteValidation] = useState<boolean | null>(null);
  const [employeeCardValidation, setEmployeeCardValidation] = useState<boolean | null>(null);
  const [metaValidation, setMetaValidation] = useState<boolean | null>(null);
  const [searchDate, setSearchDate] = useState<Dayjs | null>(null);
  const [dateError, setDateError] = useState<boolean>(true);

  const execute = useFetchMsal();
  const [loadingPunches, setLoadingPunches] = useState<boolean>(true);
  const [loadingPunchesAdj, setLoadingPunchesAdj] = useState<boolean>(true);
  const [loadingRewards, setLoadingRewards] = useState<boolean>(true);
  const [loadingDailyPay, setLoadingDailyPay] = useState<boolean>(true);
  const [loadingMeta, setLoadingMeta] = useState<boolean>(true);
  const [loadingCrunchTime, setLoadingCrunchTime] = useState<boolean>(true);
  const [loadingDomo, setLoadingDomo] = useState<boolean>(true);
  const [loadingDOMOCurated, setLoadingDomoCurated] = useState<boolean>(true);
  const [loadingMicrosSalesMenuItems, setMicrosSalesMenuItems] = useState<boolean>(true);
  const [loadingSalesOtherValidation, setMicrosSalesOther] = useState<boolean>(false);
  const [loadingSalesMiscValidation, setMicrosSalesMisc] = useState<boolean>(false);
  const [loadingDimensionsValidation, setMicrosDimensions] = useState<boolean>(false);
  const [loadingEmployeeInfoValidation, setMicrosEmployeeInfo] = useState<boolean>(false);

  const [loadingOloOrdersExportValidation, setLoadingOloOrdersExportValidation] = useState<boolean>(false);
  const [loadingOloOrdersValidation, setLoadingOloOrdersValidation] = useState<boolean>(false);
  const [loadingOloRestaurantsValidation, setLoadingOloRestaurantsValidation] = useState<boolean>(false);
  const [loadingRestaurantsHOOValidation, setLoadingRestaurantsHOOValidation] = useState<boolean>(false);
  const [loadingOloOrdersExportCateringValidation, setLoadingOloOrdersExportCateringValidation] = useState<boolean>(false);
  const [loadingOloOrdersCateringValidation, setLoadingOloOrdersCateringValidation] = useState<boolean>(false);
  const [loadingMergeOloOptInValidation, setLoadingMergeOloOptInValidation] = useState<boolean>(false);
  const [loadingOloRefundOrderValidation, setLoadingOloRefundOrderValidation] = useState<boolean>(false);
  const [loadingOloCancelOrderValidation, setLoadingOloCancelOrderValidation] = useState<boolean>(false);
  const [loadingUltiProLaborValidation, setLoadingUltiProLaborValidation] = useState<boolean>(false);
  const [loadingMicrosEmployeePunchesValidation, setLoadingMicrosEmployeePunchesValidation] = useState<boolean>(false);

  const [loadingBite, setLoadingBite] = useState<boolean>(true);
  const [loadingEmployeeCard, setLoadingEmployeeCard] = useState<boolean>(true);

  const punchesExportPOStoUKG = "Employee Punches Export from POS to UKG";
  const adjPOStoUKG = "Employee Punch Adjustments Export from POS to UKG";
  const rewards = "Torch Heroes - Export File to Rewards Gateway";
  const dailyPay = "Bartender Tips Export from UKG to DailyPay";
  const meta = "Punchh Export to Meta";
  const dailyPayNote = "*** Status should turn green after 3 PM";
  const crunchTimeStatus = "CrunchTime – Import data into Datalake";
  const domoDataPull = "DOMO – Import data into Datalake";
  const domoDataCuratedProcessed = "DOMO – Filtered data into curated database";
  const microsSalesMenuItemProdParallel = "Micros Sales Menu Item Prod Parallel - Import data into Datalake";
  const successStatusAfter10PM = "*** Status should turn green after 10 AM";
  const microsSalesOtherProdParallel = "Micros Sales Other Prod Parallel - Import data into Datalake";
  const microsEmployeeInfo = "Micros Employee Info - Import data into Datalake";
  const microsDimensions = "Micros Dimensions - Import data into Datalake";
  const microsSalesMisc = "Micros Sales Misc - Import data into Datalake";
  const bite = "Bite - Import data into Datalake";
  const employeeCard = "Employee Discount Card Details Uploaded to Paytronix";
  const oloOrdersExport = "OLO Orders exported";
  const oloOrders = "OLO Orders";
  const oloRestaurants = "OLO Restaurants";
  const oloRestaurantsHOO = "OLO Restaurants HOO";
  const oloOrdersExportCatering = "OLO Orders Export Catering";
  const oloOrdersCatering = "OLO Orders Catering";
  const mergeOloOptIn = "Merge OLO opt in";
  const oloRefundOrder = "OLO Refund Order";
  const oloCancelOrder = "OLO Cancel Order";
  const ultiProLabor = "Ulti Pro Labor";
  const microsEmployeePunches = "Micros Employee Punches";

  async function getIntegrations(date = dayjs().format("YYYY-MM-DD")) {
    // Helper function to create a delay between batches
    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    
    // Define all integrations with their parameters
    const integrations: Array<IntegrationObject> = [
      { urlParam: "punches", setter: setPunchesValidation, loadingSetter: setLoadingPunches },
      { urlParam: "adjustments", setter: setPunchesAdjValidation, loadingSetter: setLoadingPunchesAdj },
      { urlParam: "rewards", setter: setRewardsValidation, loadingSetter: setLoadingRewards },
      { urlParam: "dailyPay", setter: setDailyPayValidation, loadingSetter: setLoadingDailyPay },
      { urlParam: "meta", setter: setMetaValidation, loadingSetter: setLoadingMeta },
      { urlParam: "ImportCtUnpostedDsr", setter: setCrunchTimeValidation, loadingSetter: setLoadingCrunchTime },
      { urlParam: "DOMO", setter: setDomoValidation, loadingSetter: setLoadingDomo },
      { urlParam: "DOMOCurated", setter: setDomoCuratedValidation, loadingSetter: setLoadingDomoCurated },
      { urlParam: "MicrosSalesMenuItemProdParallel", setter: setMicrosSalesMenuItemsValidation, loadingSetter: setMicrosSalesMenuItems },
      { urlParam: "MicrosSalesOtherParallel", setter: setMicrosSalesOtherValidation, loadingSetter: setMicrosSalesOther },
      { urlParam: "MicrosDimensions", setter: setMicrosDimensionsValidation, loadingSetter: setMicrosDimensions },
      { urlParam: "MicrosSalesMisc", setter: setMicrosSalesMiscValidation, loadingSetter: setMicrosSalesMisc },
      { urlParam: "MicrosEmployeeInfo", setter: setMicrosEmployeeInfoValidation, loadingSetter: setMicrosEmployeeInfo },
      { urlParam: "bite", setter: setBiteValidation, loadingSetter: setLoadingBite },
      { urlParam: "employeeCard", setter: setEmployeeCardValidation, loadingSetter: setLoadingEmployeeCard },
      { urlParam: "OloOrdersExport", setter: setOloOrdersExportValidation, loadingSetter: setLoadingOloOrdersExportValidation },
      { urlParam: "OloOrders", setter: setOloOrdersValidation, loadingSetter: setLoadingOloOrdersValidation },
      { urlParam: "OloRestaurants", setter: setOloRestaurantsValidation, loadingSetter: setLoadingOloRestaurantsValidation },
      { urlParam: "OloRestaurantsHOO", setter: setOloRestaurantsHOOValidation, loadingSetter: setLoadingRestaurantsHOOValidation },
      { urlParam: "OloOrdersExportCatering", setter: setOloOrdersExportCateringValidation, loadingSetter: setLoadingOloOrdersExportCateringValidation },
      { urlParam: "OloOrdersCatering", setter: setOloOrdersCateringValidation, loadingSetter: setLoadingOloOrdersCateringValidation },
      { urlParam: "MergeOloOptIn", setter: setMergeOloOptInValidation, loadingSetter: setLoadingMergeOloOptInValidation },
      { urlParam: "OloRefundOrder", setter: setOloRefundOrderValidation, loadingSetter: setLoadingOloRefundOrderValidation },
      { urlParam: "OloCancelOrder", setter: setOloCancelOrderValidation, loadingSetter: setLoadingOloCancelOrderValidation },
      { urlParam: "UltiProLabor", setter: setUltiProLaborValidation, loadingSetter: setLoadingUltiProLaborValidation },
      { urlParam: "MicrosEmployeePunches", setter: setMicrosEmployeePunchesValidation, loadingSetter: setLoadingMicrosEmployeePunchesValidation }
    ];
    
    const batchSize = 2; // Number of integrations to process in parallel
    
    // Process integrations in batches
    for (let i = 0; i < integrations.length; i += batchSize) {
      // Get current batch
      const batch = integrations.slice(i, i + batchSize);
      
      // Process all items in the current batch
      const batchPromises = batch.map(integration => {
        
          integration.loadingSetter(true);
          return getStatusCall(
            integration.urlParam,
            date,
            integration.setter,
            integration.loadingSetter
          )
      });
      
      // Wait for all promises in the current batch to resolve
      await Promise.allSettled(batchPromises).then((results) => {
        results.forEach((result, index) => {
          const integration = batch[index];
          integration.loadingSetter(false);
          if (result.status === "fulfilled") {
            integration.setter(result.value.successful as boolean);
          } else {
            integration.setter(false);
            console.log(result.reason);
          }
        });
      }).catch((error) => {

        batch.forEach(integration => integration.loadingSetter(false));
        console.error("Error processing batch:", error);
      }).finally(() => {
        
        batch.forEach(integration => integration.loadingSetter(false));
      });
            
      // Only add delay if there are more batches to process
      if (i + batchSize < integrations.length) {
        await delay(2000); // Delay for 2 seconds between batches
      }
    }
  }

  const getStatusCall = function (
    urlParamName: string,
    date: string,
    setValidation: (value: React.SetStateAction<boolean | null>) => void,
    setLoading: (value: React.SetStateAction<boolean>) => void
  ) {
    setLoading(true);
    const urlCrunches = config.rootAPIList.integrationStatus
      .replace("{name}", urlParamName)
      .replace("{date}", date);


    return execute("GET", `${config.rootAPIUrl}${urlCrunches}`)
  };

  const search = function () {
    if (searchDate) {
      const date = searchDate.format("YYYY-MM-DD");
      console.log(date);
      getIntegrations(date);
    }
  };

  useEffect(() => {
    getIntegrations();
  }, []);

  return (
    <CardContainer
      className="errored-integrations"
      title="Latest Run Integration Status"
    >
      {showDateFilter ? (
        <>
          <Grid container sx={{ width: "350px" }}>
            <Grid item xs={6}>
              <DatePicker
                onError={(newError) => {
                  if (newError !== null) {
                    setDateError(true);
                  }
                }}
                value={searchDate}
                onChange={(newValue) => {
                  setSearchDate(newValue);
                  setDateError(false);
                }}
              />
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              <Button onClick={search} disabled={dateError}>
                Search
              </Button>
            </Grid>
          </Grid>
          <div className="spacer-small"></div>
        </>
      ) : (
        <></>
      )}

      <Grid container className="grid-header">
        <Grid item xs={8}>
          <Typography>Integration Name</Typography>
        </Grid>
        <Grid
          item
          xs={2}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "baseline",
          }}
        >
          <Typography>Status</Typography>
        </Grid>
        <Grid
          item
          xs={2}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "baseline",
          }}
        >
          <Typography>Ticket</Typography>
        </Grid>
      </Grid>

      <IntegrationRow
        name={punchesExportPOStoUKG}
        loading={loadingPunches}
        result={punchesValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={adjPOStoUKG}
        loading={loadingPunchesAdj}
        result={punchesAdjValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={rewards}
        loading={loadingRewards}
        result={rewardsValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={dailyPay}
        loading={loadingDailyPay}
        result={dailyPayValidation}
        note={dailyPayNote}
      ></IntegrationRow>
      <IntegrationRow
        name={crunchTimeStatus}
        loading={loadingCrunchTime}
        result={crunchTimeValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={domoDataPull}
        loading={loadingDomo}
        result={domoValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={domoDataCuratedProcessed}
        loading={loadingDOMOCurated}
        result={domoCuratedValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={microsSalesMenuItemProdParallel}
        loading={loadingMicrosSalesMenuItems}
        result={microsSalesMenuItemsValidation}
        note={successStatusAfter10PM}
      ></IntegrationRow>
      <IntegrationRow
        name={microsSalesOtherProdParallel}
        loading={loadingSalesOtherValidation}
        result={microsSalesOtherValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={microsSalesMisc}
        loading={loadingSalesMiscValidation}
        result={microsSalesMiscValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={microsDimensions}
        loading={loadingDimensionsValidation}
        result={microsDimensionsValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={microsEmployeeInfo}
        loading={loadingEmployeeInfoValidation}
        result={microsEmployeeInfoValidation}
        note={successStatusAfter10PM}
      ></IntegrationRow>
      <IntegrationRow
        name={bite}
        loading={loadingBite}
        result={biteValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={employeeCard}
        loading={loadingEmployeeCard}
        result={employeeCardValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={meta}
        loading={loadingMeta}
        result={metaValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={oloOrdersExport}
        loading={loadingOloOrdersExportValidation}
        result={oloOrdersExportValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={oloOrders}
        loading={loadingOloOrdersValidation}
        result={oloOrdersValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={oloRestaurants}
        loading={loadingOloRestaurantsValidation}
        result={oloRestaurantsValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={oloRestaurantsHOO}
        loading={loadingRestaurantsHOOValidation}
        result={oloRestaurantsHOOValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={oloOrdersExportCatering}
        loading={loadingOloOrdersExportCateringValidation}
        result={oloOrdersExportCateringValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={oloOrdersCatering}
        loading={loadingOloOrdersCateringValidation}
        result={oloOrdersCateringValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={mergeOloOptIn}
        loading={loadingMergeOloOptInValidation}
        result={mergeOloOptInValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={oloRefundOrder}
        loading={loadingOloRefundOrderValidation}
        result={oloRefundOrderValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={oloCancelOrder}
        loading={loadingOloCancelOrderValidation}
        result={oloCancelOrderValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={ultiProLabor}
        loading={loadingUltiProLaborValidation}
        result={ultiProLaborValidation}
      ></IntegrationRow>
      <IntegrationRow
        name={microsEmployeePunches}
        loading={loadingMicrosEmployeePunchesValidation}
        result={microsEmployeePunchesValidation}
      ></IntegrationRow>
    </CardContainer>
  );
}
export default IntegrationStatuses;

const IntegrationRow = function ({
  name,
  loading,
  result,
  note,
}: {
  name: string;
  loading: boolean;
  result: boolean | null;
  note?: string;
}): ReactElement {
  return (
    <Grid container className="grid-container">
      <Grid item xs={8}>
        <Typography>{name}</Typography>
        <Typography sx={{ fontSize: "12px" }}>{note}</Typography>
      </Grid>
      <Grid
        item
        xs={2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "baseline",
        }}
      >
        <LoadingIndicator show={loading}>
          {result === null ? (
            <AlbumIcon htmlColor={"#a3a3a3"}></AlbumIcon>
          ) : result === true ? (
            <AlbumIcon htmlColor={theme.palette.success.main}></AlbumIcon>
          ) : (
            <AlbumIcon htmlColor={theme.palette.error.main}></AlbumIcon>
          )}
        </LoadingIndicator>
      </Grid>
      <Grid
        item
        xs={2}
        sx={{ display: "flex", justifyContent: "end", alignItems: "baseline" }}
      >
        <CreateTicket
          buttonTitle={
            <>
              <AddIcon sx={{ marginRight: "10px" }} /> Ticket
            </>
          }
          ticketDescription={`${name} ${dayjs().format(
            "MM-DD-YYYY"
          )} FAILED please review issue.`}
          ticketSubject={`${name} ${dayjs().format("MM-DD-YYYY")} FAILED`}
        ></CreateTicket>
      </Grid>
    </Grid>
  );
};
